module.exports = __webpack_public_path__ + "static/media/medication.fec29e61.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/medication.PNG
// module id = 392
// module chunks = 0